import { render, staticRenderFns } from "./GetBlacklist.vue?vue&type=template&id=40f16136&"
import script from "./GetBlacklist.vue?vue&type=script&lang=js&"
export * from "./GetBlacklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports